import { observer } from "mobx-react";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import { Button } from "../../../../components/inputs/button/button";
import IconFile from "../../../../components/icons/icon-file/icon-file";
import localesListStore from "../../stores/locales-list-store";
import "./download-translations-container.scss";

const DownloadTranslationsContainer: React.FC = observer(() => {
    return (
        <div className="download-translations-container">
            <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{"Download translations file"}</FontBody1>
            <div>
                <FontBody2 color={FONT_COLOR.PRIMARY2}>
                    {"Get the current file with all texts that need translation. Format: CSV"}
                </FontBody2>
            </div>
            <div className="download-translations-container-cta">
                <Button text="DOWNLOAD FILE" 
                    variant={BUTTON_VARIANTS.Secondary} 
                    leftIcon={IconFile} 
                    onClick={() => localesListStore.downloadTranslations("languages_hub")} 
                    isLoading={localesListStore.isDownloading()} 
                    hasLoader={true}
                    disabled={localesListStore.isDownloading() || localesListStore.isUploading()}
                />
                {/** Not ready, uncomment when https://returngo.atlassian.net/browse/ET-956 is merged  */}
                {/*
                <FontBody2 color={FONT_COLOR.ACCENT1}>
                    {"Last Updated: "}<FontBody2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.ACCENT1}>{localesListStore.lastUpdateTimestamp}</FontBody2>
                </FontBody2>
                */}
            </div>
        </div>
    );
});

export default DownloadTranslationsContainer;